<button class="linklike" id="back">&larr; Retour</button>
<div class="playlistHeader">
  <img class="playlistCover" id="playlistCover" alt="" loading="lazy" onerror="this.classList.add('noImage')" />
  <div class="seriesInfo">
    <h1 id="playlistTitle"></h1>
    <p class="hint" id="playlistMeta"></p>
    <div class="playlistActions">
      <button id="launchBtn">Lancer cette playlist</button>
      <button class="hide" id="createStaticBtn">Créer une lounge party</button>
      <a class="linklike" id="embyLink" target="_blank" rel="noopener">Voir sur Emby</a>
    </div>
  </div>
</div>
<div id="itemList" class="episodeList"><p class="hint">Chargement...</p></div>
